import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/esm/Button';
import FormCustom from '../../Components/Form/FormCustom';
import Select from '../../Components/Form/Select';
import Input from '../../Components/Form/Input';
import CheckBox from '../../Components/Form/CheckBox';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';

const ReporteCedea = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    /* const [totales, setTotales] = useState({
        total_mxn: 0,
        total_usd: 0
    }) */

    const [periodSelected, setPeriodSelected] = useState('')
    const [period, setPeriod] = useState([])

    const [reporte, setReport] = useState({})
    const [reporteFolio, setReporteFolio] = useState({})

    const [limits, setLimits] = useState([])
    const [showAlert, setShowAlert] = useState(false);
    const [timbrarModal, setTimbrarModal] = useState({
        p_name: '',
        p_id_customers: '',
        p_id_period: '',
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen_nomina: '',
        p_id_cfdi_nomina: '',
        p_curp_customers: '',
        loadSubmit: false,
        p_facturama_error: '',
        p_subtotal: 0,
    })
    const [isr, setIsr] = useState(0)
    const [total, setTotal] = useState(0)

    const [regimen, setRegimen] = useState([]);
    const [cfdi, setCfdi] = useState([]);

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    useEffect(() => {
        Controllers.regimen.get_regimen().then(res => {
            setRegimen(res.data)
        })
        Controllers.cfdi.get_cfdi().then(res => {
            setCfdi(res.data)
        })
        Controllers.limit.get_limit().then(res => {
            setLimits(res.data)
        })
    }, [])

    const confirmTimbrar = () => {
        setTimbrarModal({
            ...timbrarModal,
            loadSubmit: true,
        })
        Controllers.facturama.send_bono_cedea_to_facturama_direct({
            p_id_customers: timbrarModal.p_id_customers,
            p_id_period: timbrarModal.p_id_period,
            p_rfc_customers: timbrarModal.p_rfc_customers,
            p_zip_code_customers: timbrarModal.p_zip_code_customers,
            p_id_regimen_nomina: timbrarModal.p_id_regimen_nomina,
            p_id_cfdi_nomina: timbrarModal.p_id_cfdi_nomina,
            p_curp_customers: timbrarModal.p_curp_customers,
            p_change_total: timbrarModal.p_change_total ? 1 : 0,
            p_subtotal: timbrarModal.p_subtotal,
            p_total: total.toFixed(2),
            p_isr: isr.toFixed(2),
        }).then(res => {
            Helpers.toast.construct({
                ...res,
                toast,
            })

            if (res.response === 'success') {
                setTimbrarModal({
                    ...timbrarModal,
                    loadSubmit: false,
                })
                setShowAlert(false)
                handleSubmit();
            } else {
                setTimbrarModal({
                    ...timbrarModal,
                    loadSubmit: false,
                })
                handleSubmit();
            }
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setTimbrarModal({
                ...timbrarModal,
                loadSubmit: false,
            })
            handleSubmit();
        })
    }

    useEffect(() => {
        let isr = 0;
        let total = 0;
        const subtotal = isNaN(parseFloat(timbrarModal.p_subtotal)) ? 0 : parseFloat(timbrarModal.p_subtotal)
        const findLimit = limits.find(l => subtotal >= l.min_limit && subtotal <= l.max_limit)

        if (findLimit) {
            isr = parseFloat((subtotal - parseFloat(findLimit.min_limit)) * parseFloat(findLimit.percentage_limit) + parseFloat(findLimit.quota_limit))
            total = subtotal - isr
        } else {
            total = timbrarModal.p_subtotal
        }

        setIsr(isr)
        setTotal(total)
    }, [timbrarModal.p_subtotal, limits])

    const handleSubmit = _ => {
        if (periodSelected === '') {
            return Helpers.toast.construct({
                response: 'warning',
                message: 'Seleccione un periodo',
                toast
            })
        }

        setRows([])
        setReport({})
        setReporteFolio({})
        setIsProccesing(true)
        Controllers.report.reporte_cedea({
            p_id_period: periodSelected
        }).then(res => {
            setRows(res.data.records)
            /* setTotales({
                total_mxn: res.data.total_mxn,
                total_usd: res.data.total_usd,
            }) */
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
            setReporteFolio({
                excel: res.data.excel_folio.file,
                filename: res.data.excel_folio.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const cboRegimen = useMemo(() => {
        if (!timbrarModal.p_id_regimen_nomina) {
            return ''
        }

        let finded = regimen.find(t => parseInt(timbrarModal.p_id_regimen_nomina) === parseInt(t.id_regimen))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_regimen} - ${finded.name_regimen}`,
            value: finded.id_regimen
        }
    }, [timbrarModal.p_id_regimen_nomina, regimen])

    const cboCfdi = useMemo(() => {
        if (!timbrarModal.p_id_cfdi_nomina) {
            return ''
        }

        let finded = cfdi.find(t => (timbrarModal.p_id_cfdi_nomina) === (t.id_cfdi))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
            value: finded.id_cfdi
        }
    }, [timbrarModal.p_id_cfdi_nomina, cfdi])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                {
                    name: 'key_branch_office', text: 'Sucursal', align: 'center', render: r => {
                        return `${r.key_branch_office} - ${r.name_branch_office}`
                    }
                },
                { name: 'total_doc', text: 'Monto', align: 'center' },
                { name: 'porcentaje_text', text: 'Porcentaje', align: 'center' },
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Nombres', align: 'center' },
                { name: 'type_fee', text: 'Régimen', align: 'center' },
                { name: 'subtotal_earnings', text: 'Subtotal', align: 'center', render: r => r.subtotal_earnings ? '$ ' + r.subtotal_earnings : '' },
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'iva', text: 'IVA', align: 'center', render: r => r.iva ? '$ ' + r.iva : '' },
                { name: 'ret_iva', text: 'RET IVA', align: 'center', render: r => r.ret_iva ? '$ ' + r.ret_iva : '' },
                { name: 'resico', text: 'RESICO', align: 'center', render: r => r.resico ? '$ ' + r.resico : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => r.total ? '$ ' + r.total : '' },
                {
                    name: 'actions', text: 'Factura', align: 'center', render: u => {
                        if (u.id_type_money !== 2) {
                            return '';
                        }

                        if (u.facturama_id) {
                            return <div className='d-flex'>
                                <div className="align-self-center">
                                    <strong className='mr-2 text-success'>FACTURADO</strong>
                                </div>
                                <a href={Helpers.config.apiUrl({
                                    url: '/facturama/bono/cedea/pdf/' + u.facturama_id
                                })} target='_blank' rel='noreferrer'>
                                    <Button variant="danger" size='xs' className='align-self-center'>
                                        <i className='fa fa-file-pdf'></i>
                                    </Button>
                                </a>
                            </div>
                        }

                        if (u.type_fee === 'ASIMILADOS') {
                            return <div>
                                <Button className="mr-1" size="xs" data-id-period={periodSelected} data-full-name={u.full_name} data-id-customers={u.id_customers} variant="dark" onClick={(e) => {

                                    let $this = e.currentTarget

                                    const { fullName, idCustomers } = e.currentTarget.dataset

                                    let buttonHTML = $this.innerHTML;
                                    $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

                                    Controllers.customers.get_customers_id({ p_id_customers: u.id_customers }).then(res => {
                                        setTimbrarModal({
                                            p_name: `${idCustomers} - ${fullName}`,
                                            p_id_customers: res.data.id_customers,
                                            p_id_period: periodSelected,
                                            p_rfc_customers: res.data.rfc_nomina,
                                            p_zip_code_customers: res.data.zip_code_nomina,
                                            p_id_regimen_nomina: res.data.id_regimen_nomina,
                                            p_id_cfdi_nomina: res.data.id_cfdi_nomina,
                                            p_curp_customers: res.data.curp_nomina,
                                            loadSubmit: false,
                                            p_change_total: parseInt(u.change_total) === 1,
                                            p_subtotal_original: u.subtotal_earnings_original,
                                            p_subtotal: parseInt(u.change_total) === 1 ? u.subtotal_changed : u.subtotal_earnings_original,
                                            p_message: u.facturama_error
                                        })
                                        setShowAlert(true)
                                    }).catch(req => {
                                        Helpers.promise.catch({ req, toast })
                                    })
                                        .finally(() => $this.innerHTML = buttonHTML)

                                }}>
                                    <i className="fas fa-file-invoice"></i>
                                </Button>
                            </div>
                        }
                    }
                },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing, periodSelected])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Reporte CEDEA</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={handleSubmit}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => {
                            setPeriodSelected(e.value)
                            setReport({})
                            setReporteFolio({})
                            setRows([])
                        }}
                        append={[
                            <Button onClick={handleSubmit}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
                <div className="d-flex">
                    {reporte?.filename ? <div className='mb-4 mr-2'>
                        <a href={reporte?.excel} download={reporte?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                    {reporteFolio?.filename ? <div className=' mb-4'>
                        <a href={reporteFolio?.excel} download={reporteFolio?.filename}>
                            <Button size="sm" variant="dark">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Folio
                            </Button>
                        </a>
                    </div> : ''}
                </div>
                {dtRows}
            </Card.Body>
        </Card>
        <SweetAlert
            icon="approve"
            iconClassName="fas fa-file-invoice text-primary"
            show={showAlert}
            showCancelButton
            title={<>¿Desea timbrar la el bono CEDEA?</>}
            subtitle={<>#{timbrarModal.p_name}</>}
            confirmButtonText="¡Sí, timbrar!"
            cancelButtonText="¡No, cancelar!"
            loadSubmit={timbrarModal.loadSubmit}
            onCancel={() => setShowAlert(false)}
            onConfirm={confirmTimbrar}
            content={_ => {
                return <>
                    {timbrarModal.p_facturama_error && <div className="col-12 mb-2">
                        <small className='text-danger'>
                            {timbrarModal.p_facturama_error}
                        </small>
                    </div>}
                    <Input
                        text="RFC"
                        placeholder="RFC"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={timbrarModal.p_rfc_customers}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_rfc_customers: e.currentTarget.value })
                        }}
                    />
                    <Input
                        text="CURP"
                        placeholder="CURP"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={timbrarModal.p_curp_customers}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_curp_customers: e.currentTarget.value })
                        }}
                    />
                    <Input
                        text="Código Postal"
                        placeholder="Código Postal"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={timbrarModal.p_zip_code_customers}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_zip_code_customers: e.currentTarget.value })
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Uso de CFDI"
                        options={cfdi.map(t => {
                            return {
                                label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                value: t.id_cfdi
                            }
                        })}
                        value={cboCfdi}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_id_cfdi_nomina: e.value, p_id_regimen_nomina: '' })
                        }}
                    />
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="far fa-building"
                        text="Régimen Fiscal"
                        options={regimen.filter(r => {
                            if (!timbrarModal.p_id_cfdi_nomina) {
                                return false
                            }

                            const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarModal.p_id_cfdi_nomina)

                            if (!cfdiAux) {
                                return false
                            }

                            return cfdiAux.regimen_ids.includes(r.id_regimen)
                        }).map(t => {
                            return {
                                label: `${t.id_regimen} - ${t.name_regimen}`,
                                value: t.id_regimen
                            }
                        })}
                        value={cboRegimen}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_id_regimen_nomina: e.value })
                        }}
                    />
                    <CheckBox
                        id="change-total"
                        classNameParent="col-12 mt-2 align-self-center"
                        text="¿Cambiar total?"
                        checked={timbrarModal.p_change_total}
                        onChange={e => {
                            setTimbrarModal({
                                ...timbrarModal,
                                p_change_total: e.currentTarget.checked,
                                p_subtotal: e.currentTarget.checked ? timbrarModal.p_subtotal : timbrarModal.p_subtotal_original
                            })
                        }}
                    />
                    <Input
                        text="Subtotal"
                        placeholder="Subtotal"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={timbrarModal.p_subtotal}
                        onChange={e => {
                            setTimbrarModal({ ...timbrarModal, p_subtotal: e.currentTarget.value })
                        }}
                        disabled={!timbrarModal.p_change_total}
                        type="number"
                        step="0.01"
                        min="0.01"
                    />
                    <Input
                        text="ISR"
                        placeholder="ISR"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseFloat(isr).toFixed(2)}
                        disabled
                    />
                    <Input
                        text="Total a Pagar"
                        placeholder="Total a Pagar"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment-alt"
                        required
                        invalid="El campo es obligatorio."
                        value={parseFloat(total).toFixed(2)}
                        disabled
                    />
                </>
            }}
        />
        {/* !isProcessing && <div className="d-flex justify-content-center mt-4">
            <div className="alert alert-success text-center">
                <h5>Total MXN: <strong>{totales.total_mxn}</strong></h5>
                <h5>Total USD: <strong>{totales.total_usd}</strong></h5>
            </div>
        </div> */}
    </>
}

export default ReporteCedea